import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/shared/ErrorBoundary";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import PeopleMovement from "@/pages/PeopleMovement";
import MaterialMovement from "@/pages/MaterialMovement";
import IncomingMaterial from "@/pages/IncomingMaterial";
import Dispatch from "@/pages/Dispatch";
import VehicleMovement from "@/pages/VehicleMovement";
import SecurityLogs from "@/pages/SecurityLogs";
import InterPlantTransfer from "@/pages/InterPlantTransfer";
import Vehicles from "@/pages/Vehicles";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import "@/App.css";

// Register Service Worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="h-screen flex items-center justify-center"><div className="animate-spin h-8 w-8 border-4 border-[#1B3C87] border-t-transparent rounded-full" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return null;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/mod1" element={<ProtectedRoute><PeopleMovement /></ProtectedRoute>} />
      <Route path="/mod2" element={<ProtectedRoute><MaterialMovement /></ProtectedRoute>} />
      <Route path="/mod3" element={<ProtectedRoute><IncomingMaterial /></ProtectedRoute>} />
      <Route path="/mod4" element={<ProtectedRoute><Dispatch /></ProtectedRoute>} />
      <Route path="/mod5" element={<ProtectedRoute><VehicleMovement /></ProtectedRoute>} />
      <Route path="/mod6" element={<ProtectedRoute><SecurityLogs /></ProtectedRoute>} />
      <Route path="/mod7" element={<ProtectedRoute><InterPlantTransfer /></ProtectedRoute>} />
      <Route path="/vehicles" element={<ProtectedRoute><Vehicles /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
